import axios from 'axios';
import Cookies from 'universal-cookie';
import { apiRoute } from '../constants/api-constants';
import { CLIENT_ZONE_HEADER, deviceZone } from '../function-utils/building-time';

const cookies = new Cookies();

// A dedicated axios instance for PUBLIC, pre-auth calls (signup, invite
// validate/accept, public plans, email verify). It stays separate from the
// default instance so these flows never pick up the global auth interceptors
// (in particular the 401 -> refresh -> retry loop, which is meaningless before a
// session exists).
//
// `withCredentials` is REQUIRED even though these are pre-auth: signup and
// invite-accept respond with the httpOnly session cookies, and the browser only
// stores Set-Cookie from a cross-origin response on a credentialed request.
export const publicApi = axios.create({
  baseURL: apiRoute as string,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// The server's double-submit guard fires on ANY state-changing request that
// arrives carrying a csrf_token cookie — it cannot tell "pre-auth" from
// "authenticated", only "cookie present". That happens here more often than it
// sounds: someone who was signed in, then opened /signup to start a second
// organization, still has the cookie. Without this echo those requests would
// 403.
//
// This instance is created separately from the default one precisely to skip
// the auth interceptors, so it does not inherit that instance's CSRF
// interceptor either and needs its own. Same three lines, no refresh/retry.
publicApi.interceptors.request.use(config => {
  const csrf = cookies.get('csrf_token');

  if (csrf && config.headers) {
    config.headers['X-CSRF-Token'] = csrf;
  }

  // The device's zone, as on the signed-in instance (axios-setup.ts): read per
  // request, omitted when the platform will not say.
  const zone = deviceZone();

  if (zone && config.headers) {
    config.headers[CLIENT_ZONE_HEADER] = zone;
  }

  return config;
});
